import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import PlayVideoIcon from '~/assets/images/play.svg';

interface VideoThumbnailProps {
  title: string;
  thumbnailUrl: string;
  onPlay: () => void;
}

const ThumbnailContainer = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  width: 170,
  height: 96,
  borderRadius: '12px',
  overflow: 'hidden',
  cursor: 'pointer',
  flexShrink: 0,

  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: 180,
  },
}));

const VideoThumbnail = ({
  title,
  thumbnailUrl,
  onPlay,
}: VideoThumbnailProps) => {
  const { t } = useTranslation('sites', { keyPrefix: 'howtoCard' });
  return (
    <ThumbnailContainer onClick={onPlay} data-testid="video-thumbnail">
      <Box
        component="img"
        src={thumbnailUrl}
        alt={title}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />

      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: 'rgba(0,0,0,0.35)',
        }}
      >
        <Stack alignItems="center" justifyContent="center">
          <Box
            component="img"
            src={PlayVideoIcon}
            alt={t('playVideo') as string}
            sx={{
              width: 38,
              height: 38,
            }}
          />
        </Stack>

        <Typography
          variant="body2"
          sx={{
            color: 'common.white',
            fontWeight: 400,
          }}
        >
          {t('playVideo')}
        </Typography>
      </Stack>
    </ThumbnailContainer>
  );
};

export default VideoThumbnail;
